// extracted by mini-css-extract-plugin
export default {"tooltip":"ApplicationAcceptedLabel_tooltip__+0p5Q","item":"ApplicationAcceptedLabel_item__8p5nH","itemName":"ApplicationAcceptedLabel_itemName__zsTfz"};